import {forEach, isEmpty} from 'lodash'
import {compactManifest, getManifestForServer} from './manifest'
import {createEmptyDocument} from './consts/document'
import {BLANK_THUMBNAIL} from './consts'
import {compactDynamicItems} from './metadata'
import {getPowtoonExportReadinessState} from 'powtoon-document/utils/content'
import {calcDocumentDuration} from 'powtoon-document/utils/duration'

export const getEmptyThumb = () => new Blob([BLANK_THUMBNAIL], {type: 'image/svg+xml'})

export function createDocumentFormData(
  document = createEmptyDocument(),
  {shouldUpdateExistingThumbnail = true, additionalFormDataProps = null, shouldApplyBaseVersion = true} = {}
) {
  const exportReadinessData = getPowtoonExportReadinessState(document.content.powtoon)
  const exportReadiness = exportReadinessData.status || null
  const documentFormData = new FormData()

  if (document.id) {
    documentFormData.append('id', document.id)
  }
  documentFormData.append('name', document.name)

  if (document.currentVersion && shouldApplyBaseVersion) {
    documentFormData.append('base_version', document.currentVersion)
  }

  if (additionalFormDataProps !== null) {
    forEach(additionalFormDataProps, (value, key) => documentFormData.append(key, value))
  }

  if (shouldUpdateExistingThumbnail) {

    const isFileThumbExists = document.thumb

    if (!isFileThumbExists && document.thumbUrl) {
      documentFormData.append('thumb_url', document.thumbUrl)
    }
    else {
      const thumb = document.thumb || getEmptyThumb()
      const thumbName = thumb.type === 'image/svg+xml' ? 'thumb.svg' : 'thumb.jpeg'
      documentFormData.append('thumb', thumb, thumbName)
    }

  }

  if (!document.duration) {
    const duration = calcDocumentDuration(document.content.powtoon.slides)
    documentFormData.append('duration', duration)
  }

  if (exportReadiness !== document.exportReadiness) {
    documentFormData.append('export_readiness', exportReadiness)
  }

  const updatedManifest = compactManifest(document.content.powtoon)
  const manifestForServer = getManifestForServer(updatedManifest)
  const content = {
    ...document.content,
    powtoon: {
      ...document.content.powtoon,
      manifest: manifestForServer
    }
  }
  if (!isEmpty(document.content.metadata)) {
    const updateDynamicItems = compactDynamicItems(document.content)
    documentFormData.append('is_dynamic', !isEmpty(updateDynamicItems))

    content['metadata'] = {
      ...document.content.metadata,
      dynamicItems: updateDynamicItems
    }
  }
  documentFormData.append('content', JSON.stringify(content))
  if (document.contentSource) {
    documentFormData.append('content_source', document.contentSource)
  }
  return documentFormData
}
